export default __webpack_public_path__ + "static/media/282.1bcc77e5.png";